// Can override the following:
//
// style
// innerStyle
// reactVirtualizedListProps
// scaffoldBlockPxWidth
// slideRegionSize
// rowHeight
// treeNodeRenderer
// nodeContentRenderer
// placeholderRenderer

import nodeContentRenderer from "./node-content-renderer";
import treeNodeRenderer from "./tree-node-renderer";

export default {
  nodeContentRenderer,
  treeNodeRenderer,
  scaffoldBlockPxWidth: 25,
  rowHeight: 25,
  slideRegionSize: 50,
  style: {},
  innerStyle: {},
  placeholderRenderer: undefined,
};
